import React from 'react'
import './index.scss'

const ConfirmRemoval = (props) => {
  const { remove, cancel, type } = props
  const handleParentClick = (e) => {
    e.stopPropagation();
  }

  return (
    <div className='confirm-removal-container-two' onClick={cancel}>
      <div className='alert-box-container' onClick={(e) => handleParentClick}>
        <div className='alert-center'>
          {/* <p style={{ fontSize: '15px', fontWeight: 'bold', textAlign: 'center' }}>{`Remove this ${type}`}</p> */}
          <p style={{ fontSize: '18px', margin: '20px', fontWeight: 'bold', textAlign: 'center', lineHeight: 1.5 }}>{`Delete this ${type == 'Photo' ? 'Photo Marker' : type} from your map and your saved content?`}</p>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
            <button
              onClick={cancel}
              style={{ margin: '0', width: '45%' }}>CANCEL</button>
            <button
              onClick={remove}
              style={{ margin: '0', backgroundColor: '#ff6800', width: '45%' }}>YES, DELETE</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConfirmRemoval